import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { PurchaseOrders, PurchaseOrdersFilters } from '../types';

export default class PurchaseOrdersState extends BaseState {
  purchase_orders: PurchaseOrders.PurchaseOrder[] = [];
  purchase_order: PurchaseOrders.PurchaseOrder | null = null;
  contractors_or_brands: string[] | null = null;
  statuses: PurchaseOrders.Status[] | string[] = [];
  status: PurchaseOrders.Status | null = null;

  filters: PurchaseOrdersFilters = {
    search: '',
    created_date: '',
    closed_date: '',
    statuses: [],
    contractors_or_brands: [],
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  loading = false;
}
